import React from 'react';
import Router from './shared/Router';
import Footer from './pages/Footer';

import { ChakraProvider, Flex } from '@chakra-ui/react';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
.use(initReactI18next)
.use(LanguageDetector)
.init({
  resources: {
    en : { translation: require('./locales/privacy-en.json') },
    ko : { translation: require('./locales/privacy-ko.json') }
  },
  fallbackLng: 'en',
  debug: true,
  interpolation: {
    escapeValue: false
  }
});

function App() {
  return (
    <ChakraProvider>
      <Flex direction="column" minHeight="100vh">
        {/* Body */}
        <Router />
        {/* Footer */}
        <Footer />        
      </Flex>
    </ChakraProvider>
  );
}

export default App;